import { TType } from '../../hooks/useTranslation';
import * as Yup from 'yup';
import { TransactionType } from '../../models/project';

export const returnCloseValidationSchema = (t: TType) =>
  Yup.object().shape({
    unitCategory: Yup.string().required('Unit Category is required').nullable(),
    projectName: Yup.string()
      .required(t('validationMessages.projectNameIsRequired'))
      .nullable(),
    unitType: Yup.string()
      .required(t('validationMessages.unitTypeIsRequired'))
      .nullable(),
    transactionType: Yup.string()
      .required(t('validation.transactionTypeRequired'))
      .nullable(),
    isLeasedFromAnotherIngkaCompany: Yup.string().when('transactionType', {
      is: TransactionType.LEASE,
      then: Yup.string().required(t('validation.leasedFromIngkaRequired')),
      otherwise: Yup.string().nullable().notRequired(),
    }),
    countryCode: Yup.string().required(t('validation.country')).nullable(),
    targetProjectStartDate: Yup.string()
      .required(t('validation.projectStartDate'))
      .nullable(),
    targetProjectEndDate: Yup.string()
      .required(t('validation.projectEndDate'))
      .nullable(),
    countryProjectResponsible: Yup.string()
      .required(t('validation.countryProjectResponsible'))
      .nullable(),
    truckFulfilmentCapacityAdjustment: Yup.string().nullable().notRequired(),
    parcelFulfilmentCapacityAdjustment: Yup.string().nullable().notRequired(),
    needForAstroDecommissioning: Yup.string().nullable().notRequired(),
    unifierId: Yup.string()
      .nullable()
      .matches(/^CMT\d{5}$/, {
        message: t('validationMessages.unifierIdWrongFormat'),
        excludeEmptyString: true,
      }),
  });
